<template>
  <div v-loading="loading" class="list-card">
    <div class="list-title">
      <span class="bullet blue-bullet"></span>
      TOP 5 KHÔNG GIAN VĂN HÓA NỔI BẬT
    </div>
    <div class="table-container">
      <table class="rank-table">
        <thead>
          <tr>
            <th style="width: 50px; text-align: center;">#</th>
            <th>TÊN KHÔNG GIAN</th>
            <th style="width: 120px;">DANH MỤC</th>
            <th>ĐỊA ĐIỂM</th>
            <th style="width: 120px; text-align: right;">LƯỢT XEM</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(space, idx) in spaces" :key="idx">
            <td style="text-align: center;">
              <span :class="['rank-badge', `rank-${idx + 1}`]">{{ idx + 1 }}</span>
            </td>
            <td class="bold-text">{{ space.name }}</td>
            <td style="text-align: center;">
              <span :class="['badge-tag', space.typeClass]">{{ space.type }}</span>
            </td>
            <td class="gray-text">{{ space.location }}</td>
            <td style="text-align: right;" class="number-text">{{ space.view_count | numberWithDelimiter }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { listPlaces } from '@/services/place'

export default {
  name: 'TopSpacesTable',
  filters: {
    numberWithDelimiter(val) {
      if (val === undefined || val === null) return '0'
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  },
  data() {
    return {
      spaces: [],
      loading: false
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created() {
    this.fetchTopSpaces()
  },
  methods: {
    getPseudoViews(id) {
      if (!id) return 0
      let hash = 0
      for (let i = 0; i < id.length; i++) {
        hash = id.charCodeAt(i) + ((hash << 5) - hash)
      }
      return Math.abs(hash % 20000) + 1200
    },
    getSpaceTypeClass(type) {
      const colors = ['badge-purple-trans', 'badge-orange-trans', 'badge-green-trans', 'badge-yellow-trans']
      const index = type.charCodeAt(0) % colors.length
      return colors[index]
    },
    fetchTopSpaces() {
      this.loading = true
      const params = {
        place_types: 'attraction',
        page: 1,
        per_page: 5,
        locale: this.language
      }
      listPlaces(params).then((response) => {
        if (response && response.result) {
          this.spaces = response.result.map((item) => {
            const typeName = item.category ? (item.category.summary || item.category.name || 'Không gian') : 'Không gian'
            return {
              id: item.id,
              name: item.name,
              type: typeName,
              typeClass: this.getSpaceTypeClass(typeName),
              location: item.address || (item.area ? item.area.name : '') || 'Hưng Yên',
              views: this.getPseudoViews(item.id)
            }
          })
        }
        this.loading = false
      }).catch((err) => {
        console.error('Failed to fetch top spaces', err)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-card {
  background: #ffffff;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  box-sizing: border-box;

  .list-title {
    font-size: 13px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    letter-spacing: 0.3px;

    .bullet {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .blue-bullet { background-color: #3498db; }
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
}

.rank-table {
  width: 100%;
  border-collapse: collapse;

  th {
    padding: 12px 10px;
    font-size: 11px;
    font-weight: 700;
    color: #7f8c8d;
    border-bottom: 2px solid #f1f1f1;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
  }

  tr {
    border-bottom: 1px solid #f9f9f9;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9fbfd;
    }
  }

  td {
    padding: 14px 10px;
    font-size: 13px;
    color: #2c3e50;
    vertical-align: middle;
  }

  .bold-text {
    font-weight: 600;
    color: #34495e;
  }

  .gray-text {
    color: #7f8c8d;
    font-weight: 500;
  }

  .number-text {
    font-weight: 700;
    font-family: 'Courier New', Courier, monospace;
    font-size: 14px;
    color: #2c3e50;
  }
}

.rank-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 800;
  color: #fff;

  &.rank-1 { background-color: #f39c12; }
  &.rank-2 { background-color: #bdc3c7; }
  &.rank-3 { background-color: #d35400; }
  &.rank-4, &.rank-5 {
    background-color: #ebf5fb;
    color: #2980b9;
    font-weight: 600;
  }
}

.badge-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;

  &.badge-purple-trans { background-color: #ebd7f7; color: #8a2be2; border: 1px solid #dcb5f2; }
  &.badge-orange-trans { background-color: #fdf2e9; color: #e67e22; border: 1px solid #f5cba7; }
  &.badge-green-trans { background-color: #e8f8f5; color: #2ecc71; border: 1px solid #a9dfbf; }
  &.badge-yellow-trans { background-color: #fef9e7; color: #f1c40f; border: 1px solid #f9e79f; }
}
</style>
